import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/web.dom.iterable';
import _classCallCheck from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _possibleConstructorReturn from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
import _inherits from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module font/fontsize/fontsizeui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import {
    createDropdown,
    addListToDropdown
} from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { normalizeOptions } from './utils';
import { FONT_SIZE } from '../utils';
import fontSizeIcon from '../../theme/icons/font-size.svg';
import '../../theme/fontsize.css';
/**
 * The font size UI plugin. It introduces the `'fontSize'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
var FontSizeUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(FontSizeUI, _Plugin);
    function FontSizeUI() {
        _classCallCheck(this, FontSizeUI);
        return _possibleConstructorReturn(this, _getPrototypeOf(FontSizeUI).apply(this, arguments));
    }
    _createClass(FontSizeUI, [
        {
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var _this = this;
                var editor = this.editor;
                var t = editor.t;
                var options = this._getLocalizedOptions();
                var command = editor.commands.get(FONT_SIZE);
                // Register UI component.
                editor.ui.componentFactory.add(FONT_SIZE, function (locale) {
                    var dropdownView = createDropdown(locale);
                    addListToDropdown(dropdownView, _prepareListOptions(options, command));
                    // Create dropdown model.
                    dropdownView.buttonView.set({
                        label: t('Font Size'),
                        icon: fontSizeIcon,
                        tooltip: true
                    });
                    dropdownView.extendTemplate({ attributes: { class: ['ck-font-size-dropdown'] } });
                    dropdownView.bind('isEnabled').to(command);
                    // Execute command when an item from the dropdown is selected.
                    _this.listenTo(dropdownView, 'execute', function (evt) {
                        editor.execute(evt.source.commandName, { value: evt.source.commandParam });
                        editor.editing.view.focus();
                    });
                    return dropdownView;
                });
            }    /**
     * Returns options as defined in `config.fontSize.options` but processed to account for
     * editor localization, i.e. to display {@link module:font/fontsize~FontSizeOption}
     * in the correct language.
     *
     * Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
     * when the user configuration is defined because the editor does not exist yet.
     *
     * @private
     * @returns {Array.<module:font/fontsize~FontSizeOption>}.
     */
        },
        {
            key: '_getLocalizedOptions',
            value: function _getLocalizedOptions() {
                var editor = this.editor;
                var t = editor.t;
                var localizedTitles = {
                    Default: t('Default'),
                    Tiny: t('Tiny'),
                    Small: t('Small'),
                    Big: t('Big'),
                    Huge: t('Huge')
                };
                var options = normalizeOptions(editor.config.get(FONT_SIZE).options);
                return options.map(function (option) {
                    var title = localizedTitles[option.title];
                    if (title && title != option.title) {
                        // Clone the option to avoid altering the original `namedPresets` from `./utils.js`.
                        option = Object.assign({}, option, { title: title });
                    }
                    return option;
                });
            }
        }
    ]);
    return FontSizeUI;
}(Plugin);
// Prepares FontSize dropdown items.
// @private
// @param {Array.<module:font/fontsize~FontSizeOption>} options
// @param {module:font/fontsize/fontsizecommand~FontSizeCommand} command
export {
    FontSizeUI as default
};
function _prepareListOptions(options, command) {
    var itemDefinitions = new Collection();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        var _loop = function _loop() {
            var option = _step.value;
            var def = {
                type: 'button',
                model: new Model({
                    commandName: FONT_SIZE,
                    commandParam: option.model,
                    label: option.title,
                    class: 'ck-fontsize-option',
                    withText: true
                })
            };
            if (option.view && option.view.styles) {
                def.model.set('labelStyle', 'font-size:'.concat(option.view.styles['font-size']));
            }
            if (option.view && option.view.classes) {
                def.model.set('class', ''.concat(def.model.class, ' ').concat(option.view.classes));
            }
            def.model.bind('isOn').to(command, 'value', function (value) {
                return value === option.model;
            });
            // Add the option to the collection.
            itemDefinitions.add(def);
        };
        for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return itemDefinitions;
}